import { useEffect, useState } from 'react';
export const useIsomorphicEffect = (effect, deps)=>{
    if (process.env.BROWSER) {
        useEffect(effect, deps);
        return;
    }
    const [hasBeenCalled, setHasBeenCalled] = useState(false);
    if (hasBeenCalled) return;
    effect();
    setHasBeenCalled(true);
};
